import {inject, observer} from "mobx-react";
import Backdrop from "js/components/core/Backdrop";
import Title from "js/components/core/SteppedPage/Title";
import Constraint from "js/components/Constraint";
import React from "react";
import ContinueButton from "js/components/core/SteppedPage/ContinueButton";
import {Link} from "@reach/router";

export default inject('page')(
  observer( ({page}) => {

    page.setSuccessConfirmation(true);

    return (
      <>
        <Backdrop>
          <Title>Uploaded successfully</Title>
        </Backdrop>

        <Constraint>
          <div className="upload-success">
            <p>Congratulations! You have successfully added <strong>{page.items.length}</strong> items to your store.</p>

            <Link to={'/my-items'} className="btn btn-pod btn-primary">Go To Your Store</Link>
          </div>
        </Constraint>
      </>
    );
  })
);
